import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  gap: 12px;

  /* first row */
  .div-ov-type {
    grid-column: 1 / 3;
  }
  .div-channel {
    grid-column: 3 / 6;
  }
  .div-organization {
    grid-column: 6 / 9;
  }
  .div-sector {
    grid-column: 9 / 13;
  }
  .div-customer-wrapper {
    grid-column: 13 / 25;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 12px;

    .div-client-sap {
      grid-column: 1 / 3;
    }
    .div-client-cnpj {
      grid-column: 3 / 6;
    }
    .div-client-name {
      grid-column: 6 / 13;
    }
  }

  /* second row */
  .div-office {
    grid-column: 1 / 3;
  }
  .div-client-inscription {
    grid-column: 3 / 6;
  }
  .div-client-address {
    grid-column: 6 / 15;
  }
  .div-order-date {
    grid-column: 15 / 18;
  }
  .div-order-number {
    grid-column: 18 / 25;
  }

  /* third row */
  .div-reasons {
    grid-column: 1 / 4;
  }
  .div-payment-terms {
    grid-column: 4 / 8;
  }
  .div-invoice-text {
    grid-column: 8 / 15;
  }
  .div-category {
    grid-column: 15 / 17;
  }
  .div-cost-element {
    grid-column: 17 / 21;
  }
  .div-selected-cost-element {
    grid-column: 21 / 25;
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CustomLabel = styled.label`
  cursor: inherit;
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};

  ${({ disabled }: { disabled?: boolean }) => css`
    cursor: inherit;
    color: ${disabled ? theme.colors.neutral.mediumhover : theme.colors.neutral.high};
  `}
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  height: -webkit-fill-available;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: ${theme.spacing.md} 0;
`

export const EmptyFieldBadge = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: ${theme.colors.primary.main};
`
